/** Matches backend `LikeTargetType.PLAYABLE_PROPERTY`. */
export const PLAYABLE_PROPERTY_LIKE_TARGET_TYPE = "playable_property" as const;

/** Matches backend `LikeTargetType.COMMENT`. */
export const COMMENT_LIKE_TARGET_TYPE = "comment" as const;

export const PROPERTY_LIKE_SIGN_IN_DESCRIPTION = "Sign in to like properties";

export const COMMENT_LIKE_SIGN_IN_DESCRIPTION = "Sign in to react";

/** Stable React Query user segment for like count endpoints (registered id or guest). */
export function getLikeRequestingUserKey(userId: string | null | undefined): string {
    return userId ? String(userId) : "anonymous";
}

/** React Query key for playable-property like counts; must match `usePropertyLike` cache writes. */
export function getPropertyLikeCountsQueryKey(
    playablePropertyId: string,
    requestingUserKey: string,
): readonly ["property-like-counts", string, string] {
    return ["property-like-counts", playablePropertyId, requestingUserKey];
}
